import { createContext, useContext } from "react";
import { defined } from "../../utilities/typeHelper";
import { ConditionField, DimensionDescriptor, FieldConfiguration, ReportField } from "../api/biClient.types";
import { AccountingBook, DimensionsStructure } from "../types/biShared.types";

export interface BiCommonDataContextType {
  dimensionsStructure?: DimensionsStructure;
  dimensions: DimensionDescriptor[];
  books: AccountingBook[];
  isMultiBook: boolean;
  editMode: boolean;
  conditions: ConditionField[];
  reportId: string | undefined;
  refreshToken: string | undefined;
  dimensionNames: string[];
  measureNames: string[];
  dataSetId: string;
  onFieldWithCustomConditionUpdate?: (field: ReportField, change: Partial<FieldConfiguration>) => void;
  onConditionUpdate: (field: ConditionField, changes: Partial<ConditionField>) => void;
  onRefreshGrid: () => void;
}

export const BiCommonDataContext = createContext<BiCommonDataContextType | undefined>(undefined);

export const useBiCommonDataContext = () => {
  const context = useContext(BiCommonDataContext);
  return defined(context);
};
